module.exports = __webpack_public_path__ + "img/11.c43a82eb.svg";